module.exports = __webpack_public_path__ + "static/img/calendar.0be8a10c.png";